import React from 'react';
import { SimpleCrudManager } from '../components/SimpleCrudManager';

export function CategoriesPage() {
  return (
    <SimpleCrudManager
      title="Categories"
      subtitle="Manage kit categories (e.g. Summer, Landscapes, Kids) — a kit can belong to several"
      apiPath="categories"
      itemNoun="Category"
      responseKey="categories"
    />
  );
}